import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTelegram,
  faGithub,
  faFacebook,
  faInstagram,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";

// Data configurations extracted for cleaner code
const SOCIAL_LINKS = [
  { id: "telegram", icon: faTelegram, url: "https://t.me/Gabi12boy", color: "bg-blue-500 hover:bg-blue-600 hover:shadow-blue-500/20" },
  { id: "github", icon: faGithub, url: "https://github.com/gebrie-dev", color: "bg-gray-800 hover:bg-gray-900 hover:shadow-gray-800/20" },
  { id: "facebook", icon: faFacebook, url: "https://facebook.com", color: "bg-blue-600 hover:bg-blue-700 hover:shadow-blue-600/20" },
  { id: "instagram", icon: faInstagram, url: "https://instagram.com", color: "bg-pink-600 hover:bg-pink-700 hover:shadow-pink-600/20" },
  { id: "twitter", icon: faTwitter, url: "https://x.com", color: "bg-neutral-800 hover:bg-neutral-900 hover:shadow-neutral-800/20" },
];

const TECHNOLOGIES = ["MongoDB", "Express.js", "React", "Node.js", "Tailwind CSS"];

const CONTACT_INFO = [
  { id: "email", icon: faEnvelope, text: "gabiwagnew@gmail.com", href: "mailto:gabiwagnew@gmail.com" },
  { id: "phone", icon: faPhone, text: "+251 914 080 045", href: "tel:+251914080045" },
];

const Footer = ({ isDarkMode }) => {
  const currentYear = new Date().getFullYear();

  // Consolidated theme classes
  const themeBg = isDarkMode ? "bg-gray-900 text-gray-100" : "bg-white text-gray-800";
  const textMuted = isDarkMode ? "text-gray-300" : "text-gray-600";
  const textHeading = isDarkMode ? "text-white" : "text-gray-900";
  const linkHover = isDarkMode ? "hover:text-blue-400" : "hover:text-blue-600";
  const iconColor = isDarkMode ? "text-blue-400" : "text-blue-600";
  const borderTheme = isDarkMode ? "border-gray-800 text-gray-400" : "border-gray-200 text-gray-500";

  return (
    <footer className={`py-12 transition-colors duration-300 ${themeBg}`}>
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          
          {/* Logo and Social Links */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-6">
              <div className="relative group cursor-pointer">
                {/* Updated logo to match Navbar */}
                <img
                  src="/gebre-logo.svg"
                  alt="Gebre Logo"
                  className="h-12 w-12 rounded-full mr-4 transition-transform duration-300 group-hover:scale-110"
                />
                <div className="absolute inset-0 rounded-full bg-blue-600 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
              </div>
              <h2 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
                Gebre
              </h2>
            </div>
            <p className={`mb-6 max-w-sm leading-relaxed ${textMuted}`}>
              Building amazing web experiences with modern technologies. 
              Focused on scalable SaaS and robust web applications.
            </p>
            
            <div className="flex flex-wrap gap-4">
              {SOCIAL_LINKS.map(({ id, icon, url, color }) => (
                <a
                  key={id}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Visit my ${id}`}
                  className={`w-10 h-10 flex items-center justify-center rounded-full text-white transition-all duration-300 hover:-translate-y-1 hover:shadow-lg ${color}`}
                >
                  <FontAwesomeIcon icon={icon} className="text-lg" />
                </a>
              ))}
            </div>
          </div>

          {/* Technologies */}
          <div>
            <h3 className={`text-lg font-semibold mb-4 tracking-wide ${textHeading}`}>
              Technologies
            </h3>
            <ul className="space-y-2">
              {TECHNOLOGIES.map((tech) => (
                <li key={tech}>
                  <span className={`transition-colors duration-300 cursor-default font-medium ${textMuted} ${linkHover}`}>
                    {tech}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className={`text-lg font-semibold mb-4 tracking-wide ${textHeading}`}>
              Contact
            </h3>
            <ul className="space-y-3">
              {CONTACT_INFO.map(({ id, icon, text, href }) => (
                <li key={id} className="flex items-center group cursor-pointer">
                  <FontAwesomeIcon
                    icon={icon}
                    className={`w-4 h-4 mr-3 transition-transform duration-300 group-hover:scale-110 ${iconColor}`}
                  />
                  <a
                    href={href}
                    className={`transition-colors duration-300 font-medium ${textMuted} ${linkHover}`}
                  >
                    {text}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className={`border-t mt-12 pt-8 text-center text-sm font-medium transition-colors duration-300 ${borderTheme}`}>
          <p>© {currentYear} Gebre Wagnew. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;